module.exports = __webpack_public_path__ + "stylesheets/landing-new_9f9173d26db692f680687072d2fead69.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/landing-new.less
// module id = 3Sex
// module chunks = 55